document.addEventListener("DOMContentLoaded", () => {

    const setupScrollHandler = () => {
       const GAP = 100;
 
       const handleClick = (e) => {
        
          const triggerBtn = e.target.closest("[data-scroll-to]");
          const anchorLink = e.target.closest("a[href^='#'], a[href^='/#']");
          let targetSelector = null;
 
          if (triggerBtn) {
             targetSelector = triggerBtn.dataset.scrollTo;
          } else if (anchorLink) {
             targetSelector = anchorLink.getAttribute("href").replace(/^\/#/, "#");
          }
          
 
          if (!targetSelector) return;
 
          const destination = document.querySelector(targetSelector);
          if (!destination) return;
 
          e.preventDefault();
 
          const absolutePos = destination.getBoundingClientRect().top + window.pageYOffset;
          const finalPos = absolutePos - GAP;
 
          window.scrollTo({
             top: finalPos,
             behavior: "smooth"
          });
       };
 
       document.addEventListener("click", handleClick);
    };
 
    setupScrollHandler();
 
});
 